// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreatePeriodResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payroll/create_period
 *
 * Returns the created payroll period record with all fields.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_CreatePeriodResponseDados {
id: number
franchise_id: number
user_id: string
period_start_date: string
period_end_date: string
revenue_conciliation_amount: string
expenses_conciliation_amount: string
status: number
total_amount: string
created_at: string
updated_at: string
calculated_at?: string
paid_at?: string
paid_by?: string
}

export type Payroll_CreatePeriodResponse = ApiResponse<Payroll_CreatePeriodResponseDados>;

registerResponseContract('Payroll_CreatePeriodResponse', {
  id:                           { type: 'number',  required: true },
  franchise_id:                 { type: 'number',  required: true },
  user_id:                      { type: 'string',  required: true },
  period_start_date:            { type: 'string',  required: true },
  period_end_date:              { type: 'string',  required: true },
  revenue_conciliation_amount:  { type: 'string',  required: true },
  expenses_conciliation_amount: { type: 'string',  required: true },
  status:                       { type: 'number',  required: true },
  total_amount:                 { type: 'string',  required: true },
  created_at:                   { type: 'string',  required: true },
  updated_at:                   { type: 'string',  required: true },
  calculated_at:                { type: 'string',  required: false },
  paid_at:                      { type: 'string',  required: false },
  paid_by:                      { type: 'string',  required: false },
})
